<template>
  <a-select
    v-model:value="value"
    placeholder="请选择"
    style="width: 100%"
    :allowClear="true"
    show-search
    :options="selectDatas"
    @change="onChange"
  ></a-select>
</template>
<script lang='ts' setup>
import { defineProps, defineEmits, computed, onMounted, ref } from 'vue';
import request from '@/utils/request'
import { useStore } from 'vuex'

const store = useStore()

const suggestionData: any = computed(() => store.state.platforms)
const selectDatas = ref([])
onMounted(async () => {
  await getCpeProjects()
})

async function getCpeProjects () {
  try {
    const rsp = await request.get('/api/in/kol/cpe/admin/project',{pageSize: 1000})
    let cpeProjects = rsp.data.list.map(v=>({label:v.projectNameOuter,value:v.projectNameOuter}))
    selectDatas.value = suggestionData.value.concat(cpeProjects)
  } catch(err) {
    console.log('err')
  }
}
const props = defineProps({
  modelValue: {
    type: String,
  },
})

const emits = defineEmits(['update:modelValue'])

const value: any = computed({
  set(val) {
    emits('update:modelValue', val)
  },
  get() {
    return props.modelValue
  },
})

const onChange = (item, options) => {
  if (item) {
    emits('update:modelValue', item)
  }
}
</script>
<style lang='scss' scoped>

</style>